import React, { useReducer } from 'react'
import dashboardFilter from '../utils/dashboardFilter'

function useQueryReducer() {

    const initialState = dashboardFilter.initialFilterState

    const reducer = (state, action) => {
        return {...state, ...action}
    }

    const [state, dispatch] = useReducer(reducer, initialState)

    const clearAllFilters = () => {
        dispatch(initialState)
    }

    return {
        initialState,
        state,
        dispatch,
        clearAllFilters
    }

}

export default useQueryReducer